export const selectHolidays = (state) => state.companyHoliday?.holidays || [];
export const selectHolidayLoading = (state) =>
  state.companyHoliday?.loading || false;
export const selectHolidayError = (state) =>
  state.companyHoliday?.error || null;
export const selectSelectedHoliday = (state) =>
  state.companyHoliday?.selectedHoliday || null;
